export const NFTCONTRACT = "0x25504219e8f3C07004536Bb992718a190630bd49";
export const STAKINGCONTRACT = "0xFA657694C135A0c865729d7aF278AE14165cf72F";
export const bsc_rpc = "https://api-testnet.bscscan.com/api";
export const moralisapi = "https://deep-index.moralis.io/api/v2";
export const nftpng = "https://aqua-neat-fish-428.mypinata.cloud/ipfs/QmRXiJi5ofSRAndCKi1rWWn68DhmYzoWXvXeMfR1g8KxjU/";